import { createTheme } from '@mui/material';

const ThemesApp = createTheme({
    palette: {
        primary: {
            main: '#333333c0'
        },
        secondary: {
            main: '#303f9fff'
        }

    },
});


export default ThemesApp;